export enum UserType {
  Moderator = 'Moderator',
  SelfServicedPilot = 'Self-serviced Pilot',
  TaPilot = 'TA Pilot',
}
